// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ToolsSidebar-cls1___22559a1667bd45f24b4{/*!*/}.ToolsSidebar-cls2__e354eda0666f358517fa{position:absolute;min-height:100%;width:400px;max-width:80vw;right:0;background:#fff;padding:12px 12px 48px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ToolsSidebar-cls1___22559a1667bd45f24b4",
	"cls2": "ToolsSidebar-cls2__e354eda0666f358517fa ToolsSidebar-cls1___22559a1667bd45f24b4"
};
export default ___CSS_LOADER_EXPORT___;
